exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-slider-wrapper[data-v-6964b5a8]{width:100%;max-width:500px;padding-bottom:10px;margin:auto}.v-carousel__controls[data-v-6964b5a8]{display:none!important}.embed-slider-wrapper .v-window-item[data-v-6964b5a8]{padding-left:0;padding-right:0}", ""]);

// exports
